import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const DepartmentRoutes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "DepartmentList",
    component: () => import("../views/Department.vue"),
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.DEPARTMENT.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.DEPARTMENT.PERMISSIONS,
    },
  },
];

export default DepartmentRoutes;
